import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faCopy, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import Editor from '@monaco-editor/react';
import { toast } from 'react-toastify';

const Base64Tool= (props) => {
  const { editorTheme } = props
  const [originalInput, setOriginalinput] = useState('');
  const [output, setOutput] = useState('');
  const [isEncode, setIsEncode] = useState(true);

  const showErrorMessage = (errorMessage) => {
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const handleSwitch = () => {
    setIsEncode(!isEncode);
    setOriginalinput('');
    setOutput('');
  }
  const handleInputText = (value, event) => {
    setOriginalinput(value);
    if (value === '') {
      return setOutput('');
    }
    try {
      if (isEncode) {
        const encoded = btoa(value);
        setOutput(encoded);
      } else {
        const decoded = atob(value);
        setOutput(decoded);
      }
    } catch (error) {
      setOutput('');
      showErrorMessage('Invalid text input.')
    }
  }
  const handleCopyOutput = () => {
    navigator.clipboard.writeText(output);
  }

  useEffect(() => {
    if (originalInput === '') {
      return setOutput('');
    }
  }, [originalInput, output, isEncode]);
  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>{ isEncode ? 'Original' : 'Encoded' } Text Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-600 rounded dark:border-gray-600">
            <Editor
              value={originalInput}
              language="text"
              onChange={(value, event) => handleInputText(value, event)}
              height="40vh"
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400rounded dark:border-gray-600">
            <button
              onClick={() => setOriginalinput('') }
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
            &nbsp;&nbsp;
            <button
              onClick={handleSwitch}
              type="button"
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faExchangeAlt}/>
              &nbsp; Switch Mode
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>{ isEncode ? 'Encoded' : 'Decoded' } text outpput</h3>
          </div>
          <div className="px-4 py-2 text-gray-600 rounded dark:border-gray-600">
            <Editor
              language="text"
              value={output}
              height="40vh"
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-600 rounded dark:border-gray-600">
            <button
              onClick={handleCopyOutput}
              type="button"
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCopy}/>
              &nbsp; Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Base64Tool;
